import {Component, Mixins} from "vue-property-decorator";
import {resetPassword} from "~/modules/auth/service";
import {ChangePasswordStep} from "~/modules/auth/components/change-password-step";

@Component
class ChangePasswordPasswordStep extends Mixins(ChangePasswordStep) {
  protected async sendRequest() {
    await resetPassword({
      code: this.code,
      password: this.nextPassword
    });
  }
}

export {ChangePasswordPasswordStep}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7e9b88bc/change-password-password-step.tsx" });